import { jsx as w } from "react/jsx-runtime";
import { forwardRef as x, useMemo as y, cloneElement as S } from "react";
import { c as o } from "./tw-cn-mXgPecoF.mjs";
import { e as v } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { r as B } from "./rectangle-button.styles-DSiIlHIf.mjs";
import { c as s } from "./index-BpNK5r1N.mjs";
const N = s(["aspect-square p-4 "], {
  variants: {
    size: {
      xLarge: "min-h-56 min-w-56 rounded-16",
      large: "min-h-52 min-w-52 rounded-16",
      medium_plus: "min-h-44 min-w-44 rounded-12",
      medium: "min-h-40 min-w-40 rounded-12",
      small: "min-h-32 min-w-32 rounded-10"
    },
    pcSize: {
      xLarge: "pc:min-h-56 pc:min-w-56 pc:rounded-16",
      large: "pc:min-h-52 pc:min-w-52 pc:rounded-16",
      medium_plus: "pc:min-h-44 pc:min-w-44 pc:rounded-12",
      medium: "pc:min-h-40 pc:min-w-40 pc:rounded-12",
      small: "pc:min-h-32 pc:min-w-32 pc:rounded-10"
    }
  }
}), I = s("", {
  variants: {
    size: {
      xLarge: "size-32",
      large: "size-24",
      medium_plus: "size-24",
      medium: "size-24",
      small: "size-20"
    },
    pcSize: {
      xLarge: "pc:size-32",
      large: "pc:size-24",
      medium_plus: "pc:size-24",
      medium: "pc:size-24",
      small: "pc:size-20"
    }
  }
}), L = x(
  ({ theme: r = "filled_primary", disabled: i = !1, size: t, disabledType: a = "default", ...p }, l) => {
    const { children: u, type: d = "button", icon: e, className: z, ...f } = p, n = v({
      property: t,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: { mobile: "medium", pc: "xLarge" }
    }), h = B({ theme: r, disabledType: a }), g = N({ ...n }), m = I({ ...n }), c = y(
      () => e ? S(e, {
        className: o(m, e.props.className)
      }) : null,
      [e, m]
    );
    return /* @__PURE__ */ w(
      "button",
      {
        "aria-disabled": i,
        className: o(h, g, z),
        disabled: i,
        ref: l,
        tabIndex: i ? -1 : 0,
        type: d,
        ...f,
        children: c || u
      }
    );
  }
);
L.displayName = "NDS.IconButton";
export {
  L as I
};
